const sideBarOptions = [
  {
    url: "/dashboard",
    name: "Dashboard",
    locations: "",
    hasSubMenu: false,
    iconClass: "bx bxs-dashboard",
    subMenu: [],
    right_id: 0,
  },
  // {
  //   url: "doubts",
  //   name: "Doubts",
  //   locations:"doubts",
  //   hasSubMenu: false,
  //   iconClass:"fa-regular fa-circle-question",
  //   subMenu:[],
  //   right_id:1,
  // },
  {
    url: "createPaper",
    name: "Create Paper",
    locations: "createPaper",
    hasSubMenu: false,
    iconClass: "fa-regular fa-pen-to-square",
    subMenu: [],
    right_id: 57,
  },
  {
    url: "#",
    name: "Questions",
    // If there is any submenu then save the multiple locations used inside the submenu as given below array
    locations: [
      // "verifyQuestion",
      "editQuestion",
      "search-question",
      // "approveQuestion"
    ],
    hasSubMenu: true,
    iconClass: "fa-regular fa-clone",
    right_id: null,
    rigths_arr: [56, 13],
    subMenu: [
      // {
      //     url:"verifyQuestion",
      //     name:"Verify Question",
      //     locations:"verifyQuestion",
      //     right_id:16,
      // },
      // {
      //     url:"approveQuestion",
      //     name:"Approve Question",
      //     locations:"approveQuestion",
      //     right_id:16,
      // },
      {
        url: "editQuestion",
        name: "Edit Question",
        locations: "editQuestion",
        right_id: 13,
      },
      {
        url: "search-question",
        name: "Search Question",
        locations: "search-question",
        right_id: 56,
      },
    ]
  },
  {
    url: "paperFormat",
    name: "Paper Format",
    locations: "paperFormat",
    hasSubMenu: false,
    iconClass: "fa-solid fa-align-left",
    subMenu: [],
    right_id: 10
  },
  {
    url: "publishPaper",
    name: "Publish Paper",
    locations: "publishPaper",
    hasSubMenu: false,
    iconClass: "fa-regular fa-square-check",
    subMenu: [],
    right_id: 15,
  },
  {
    url: "facultyPaperRemove",
    name: "Faculty Paper Remove",
    locations: "facultyPaperRemove",
    hasSubMenu: false,
    iconClass: "fa-regular fa-square-check",
    subMenu: [],
    right_id: 58,
  },
  {
    url: "editTopic",
    name: "Edit Topic",
    locations: "editTopic",
    hasSubMenu: false,
    iconClass: "fa-solid fa-t",
    subMenu: [],
    right_id: 37,
  },
  {
    url: "editSubTopic",
    name: "Edit Sub-Topic",
    locations: "editSubTopic",
    hasSubMenu: false,
    iconClass: "fa-solid fa-tenge-sign",
    subMenu: [],
    right_id: 36,
  },

  {
    url: "requestPaper",
    name: "Request Paper",
    locations: "requestPaper",
    hasSubMenu: false,
    iconClass: "fa-regular fa-share-from-square",
    subMenu: [],
    right_id: 59,
  },
  {
    url: "editPaper",
    name: "Edit Request",
    locations: "editPaper",
    hasSubMenu: false,
    iconClass: "fa-regular fa-note-sticky",
    subMenu: [],
    right_id: 60,
  },
  {
    url: "deletePaper",
    name: "Delete Request",
    locations: "deletePaper",
    hasSubMenu: false,
    iconClass: "fa-solid fa-trash-can-arrow-up",
    subMenu: [],
    right_id: 61
  },
  {
    url: "copyRequest",
    name: "Copy Request",
    locations: "copyRequest",
    hasSubMenu: false,
    iconClass: "fa-solid fa-trash-can-arrow-up",
    subMenu: [],
    right_id: 50
  },
  {
    url: "bulkPaperRequest",
    name: "Bulk Paper",
    locations: "bulkPaperRequest",
    hasSubMenu: false,
    iconClass: "fa-regular fa-share-from-square",
    subMenu: [],
    right_id: 41,
  },
  {
    url: "bulkQuestionRequest",
    name: "Bulk Question",
    locations: "bulkQuestionRequest",
    hasSubMenu: false,
    iconClass: "fa-regular fa-share-from-square",
    subMenu: [],
    right_id: null,
    rigths_arr: [42, 51],
  },
  // {
  //   url: "pdfreader",
  //   name: "Pdf Reader",
  //   locations:"bulkQuestionRequest",
  //   hasSubMenu: false,
  //   iconClass:"fa-regular fa-share-from-square",
  //   subMenu:[],
  //   right_id:0,

  // },
  {
    url: "exerciseDpp",
    name: "DPP&Exercise Upload",
    locations: "DppExerciseUpload",
    hasSubMenu: false,
    iconClass: "fa-regular fa-share-from-square",
    subMenu: [],
    right_id: 62,
  },
  {
    url: "courseReport",
    name: "Course Report",
    locations: "courseReport",
    hasSubMenu: false,
    iconClass: "fa-solid fa-chart-column",
    subMenu: [],
    right_id: 43,
  },

  {
    url: "schedule",
    name: "My Schedule",
    locations: "schedule",
    hasSubMenu: false,
    iconClass: "fa-regular fa-calendar-check",
    subMenu: [],
    right_id: 44,
  },
  {
    url: "otplist",
    name: "OTP List",
    locations: "publishPaper",
    hasSubMenu: false,
    iconClass: "fa-regular fa-square-check",
    subMenu: [],
    right_id: 53,
  },
  {
    url: "question-list",
    name: "Question List",
    locations: "question-list",
    hasSubMenu: false,
    iconClass: "fa-regular fa-clone",
    subMenu: [],
    right_id: 48,
  },

  {
    url: "userList",
    name: "User List",
    locations: "userList",
    hasSubMenu: false,
    iconClass: "fa-solid fa-users",
    subMenu: [],
    right_id: 4,
  },
  {
    url: "profileList",
    name: "Profile List",
    locations: "profileList",
    hasSubMenu: false,
    iconClass: "fa-regular fa-id-card",
    subMenu: [],
    right_id: 24,
  },
  {
    url: "facultyError",
    name: "Faculty Error Report",
    locations: "facultyError",
    hasSubMenu: false,
    iconClass: "fa-regular fa-id-card",
    subMenu: [],
    right_id: 47,
  },
  {
    url: "questionIngestion",
    name: "Question Ingestion",
    locations: "questionIngestion",
    hasSubMenu: false,
    iconClass: "fa-regular fa-pen-to-square",
    subMenu: [],
    right_id: 55,
  },
  {
    url: "search-question-list",
    name: "Search Question List",
    locations: "search-question-list",
    hasSubMenu: false,
    iconClass: "fa-regular fa-pen-to-square",
    subMenu: [],
    right_id: 63,
  },
  {
    url: "attendance",
    name: "Student Attendance",
    locations: "DppExerciseUpload",
    hasSubMenu: false,
    iconClass: "fa-regular fa-pen-to-square",
    subMenu: [],
    right_id: 64,
  },
  {
    url: "facultyPaperCorrection",
    name: "Paper Corrections",
    locations: "facultyPaperCorrection",
    hasSubMenu: false,
    iconClass: "fa-regular fa-share-from-square",
    subMenu: [],
    right_id: 0,
  },
  {
    url: "papercorrectionList",
    name: "Paper Error Report",
    locations: "papercorrectionList",
    hasSubMenu: false,
    iconClass: "fa-regular fa-share-from-square",
    subMenu: [],
    right_id: 0,
  },
];

export default sideBarOptions;